<template>
    <ModalApp :name="modal_id" style="overflow-y: auto;">
        <template v-slot:modal-header>
            <div>
                <c-heading-2 class="title mb-0">
                    Personalize seu produto!
                </c-heading-2>
                <c-span>
                    Adicione itens com os quais iremos personalizar seu
                    produto.
                </c-span>
            </div>
        </template>
        <slot>
            <div class="modal-body">
                <div class="additional-items">
                    <div
                        v-for="item in additionalItems"
                        :key="item.id"
                        class="additional-item"
                    >
                        <div class="d-flex align-items-center">
                            <div
                                :class="[
                                    'input-check',
                                    item.selected ? 'checked' : ''
                                ]"
                                @click="selectAdditionalItem(item)"
                            ></div>
                            <div v-if="item.image_main">
                                    <img
                                    :src="item.image_main"
                                    loading="lazy"
                                    width="70"
                                    height="70"
                                    :alt="item.abbreviation"
                                    class="additional-item__image"
                                />
                            </div>
                            <div class="additional-item__detailed">
                                <span class="additional-item__name">
                                    <strong>{{ item.abbreviation }}</strong>
                                </span>
                                <span class="additional-item__price">
                                    <strong>
                                        {{ currency.money(item.price) }}
                                    </strong>
                                </span>
                                <div
                                    class="additional-item__description"
                                    v-if="item.pro_desc_min"
                                    v-html="item.pro_desc_min"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-lg-6">
                        <c-form-group class="form-group">
                            <label
                                for="observation_additional_items"
                                class="m-0"
                            >
                                <strong>Observações</strong>
                            </label>
                            <textarea
                                v-model="form.observation"
                                id="observation_additional_items"
                                class="form-control form-control-sm"
                                style="resize: none; max-width: 100%"
                            ></textarea>
                        </c-form-group>
                    </div>
                    <div class="col-lg-6">
                        <c-label class="m-0">
                            <strong>Anexar imagem ou PDF</strong>
                        </c-label>
                        <VueFileAgent
                            ref="vueFileInvoice"
                            :theme="'list'"
                            :multiple="false"
                            accept=".pdf, .jpg, .png, .webp, .cdr, .jpeg"
                            v-model="form.files"
                            :maxSize="'10MB'"
                            :errorText="{
                                type:
                                    'Formato de arquivo inválido. Somente imagens ou PDF.',
                                size:
                                    'O tamanho do arquivo não devem exceder 10MB.'
                            }"
                            :deletable="true"
                            :helpText="'Anexar imagem ou PDF'"
                            @beforedelete="onBeforeDelete($event)"
                            @select="filesSelected($event)"
                            @delete="fileDeleted($event)"
                        ></VueFileAgent>
                    </div>
                </div>
            </div>
            <div class="modal-footer h-auto">
                <c-ancora
                    :backgroundColor="
                        $root.$children[0].theme.products.button
                            .background_color
                    "
                    :backgroundColorHover="
                        $root.$children[0].theme.products.button
                            .background_color_hover
                    "
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="
                        $root.$children[0].theme.products.button.color_hover
                    "
                    :borderColor="
                        $root.$children[0].theme.products.button
                            .border_color
                    "
                    :borderColorHover="
                        $root.$children[0].theme.products.button
                            .border_color_hover
                    "
                    :borderRadius="
                        $root.$children[0].theme.products.button
                            .border_radius
                    "
                    :textTransform="
                        $root.$children[0].theme.products.button
                            .text_transform
                    "
                    href="#"
                    :fontSize="$root.$children[0].theme.font_size_button"
                    @click.prevent.stop="addAdditionalItems"
                    class="paction purchase"
                >
                    <span
                        :style="
                            'text-transform:' +
                                $root.$children[0].theme.products.button
                                    .text_transform +
                                '; min-width: 8rem; font-size:' +
                                $root.$children[0].theme.font_size_button
                        "
                    >
                        Adicionar
                    </span>
                </c-ancora>
            </div>
        </slot>
    </ModalApp>
</template>

<script>
import { CAncora } from "../Styles/Button/styled";
import Currency from "../../helpers/parseCurrency";
import {
    CFormGroup,
    CHeading2,
    CLabel,
    CSpan
} from "../Styles/Components/styled";
import { CModalContent } from "../Styles/Template/styled";
import ModalApp from '../ModalApp.vue'
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: "ProductCustomization",
    components: {
        "c-ancora": CAncora,
        "c-heading-2": CHeading2,
        "c-span": CSpan,
        "modal-content": CModalContent,
        "c-form-group": CFormGroup,
        "c-label": CLabel,
        ModalApp
    },
    props: {
        modal_id: {
            required: true
        },
    },
    data() {
        return {
            currency: Currency,
            form: {
                observation: null,
                files: null
            }
        };
    },
    methods: {
        ...mapActions("products", ["setAdditionalItemsSelected"]),
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast",
            "setShowToastConfirm",
        ]),
        alertToast(msg = null, confirm = false, icon = "exclamation", theme = 'warning', timer = 5) {
            this.setThemeToast(theme)
            this.setMessageToast(msg)
            this.setIconToast(icon)
            this.setTimerToast(timer)
            if(confirm) {
                this.setShowToastConfirm(true)
            } else {
                this.setShowToast(true)
                setTimeout(() => {
                    this.setShowToast(false)
                }, (timer * 1000));
            }
        },
        addAdditionalItems() {
            let selecteds = this.additionalItems.filter(el => el.selected)
            if(!this.form.files && !this.form.observation && !selecteds.length) {
                this.alertToast("Adicione ao menos um item para continuar!", true)
                return
            }
            let data = {
                items: selecteds,
                ...this.form
            }
            this.setAdditionalItemsSelected(data)
            this.alertToast("Itens adicionados ao produto!", false, "check", "success")
            this.$root.closeModalApp(this.modal_id)
        },
        selectAdditionalItem(item) {
            if (this.getValidationSelectOnlyOneAdditionalItem && !item.selected) {
                this.additionalItems.map(el => (el.selected = false));
            }
            item.selected = !item.selected;
        },
        fileDeleted(event) {

        },
        filesSelected(event) {
            if(!event || !event[0]) {
                return
            }
            const el = event[0] ?? event;
            el.file_name = el.file.name

            if(el.type != 'application/pdf' && el.type != 'application/vnd.corel-draw') {
                return
            }
            const reader = new FileReader()
            reader.readAsDataURL(el.file)
            reader.onload = () => {
               this.form.files.urlResized = reader.result
            };
            reader.onerror = (error) => {
                console.log('Error: ', error)
            };
        },
        onBeforeDelete: function(fileRecord) {
            this.$refs.vueFileInvoice.deleteFileRecord(fileRecord);
        },
        resetForm() {
            this.form.observation = null
            this.form.files = null
        }
    },
    watch: {
        additionalItemsSelected(data) {
            if(!data) {
               this.resetForm()
            }
        },
    },
    computed: {
        ...mapState("products", [
            "additionalItems",
            "additionalItemsSelected",
        ]),
        ...mapGetters("products", [
            "getValidationSelectOnlyOneAdditionalItem",
        ])
    },
};
</script>

<style lang="scss" scoped>
.additional-items {
    columns: 2;
    column-gap: 4rem;
    column-rule: 1px solid #f1f1f1;

    @media (max-width: 991px) {
        columns: 1;
    }
}

.additional-item {
    -webkit-column-break-inside: avoid; /* Chrome, Safari, Opera */
    page-break-inside: avoid; /* Firefox */
    break-inside: avoid; /* IE 10+ */
    margin-block: 0.5rem;

    &__image {
        margin-right: 1rem;
        min-width: 70px;
    }

    .input-check {
        border: 1px solid #cacaca;
        min-width: 2.1rem;
        width: 2.1rem;
        height: 2.1rem;
        cursor: pointer;
        position: relative;
        margin-right: 1rem;
        &.checked {
            background: #28a745;
            &::before {
                font-size: 1.1rem;
                content: "\f00c";
                font-family: "Font Awesome 5 Free";
                font-weight: 900;
                -webkit-font-smoothing: antialiased;
                text-indent: 0;
                position: absolute;
                left: 0;
                top: 50%;
                width: 100%;
                color: #fff;
                height: 12px;
                line-height: 12px;
                margin-top: -6px;
                text-align: center;
            }
        }
    }

    &__detailed {
        display: grid;
        grid-template-areas: "A B" "C C";
        align-items: center;
        width: 100%;
    }

    &__name {
        margin-right: 1rem;
        grid-area: A;
    }

    &__price {
        text-align: right;
        grid-area: B;
    }

    &__description {
        grid-area: C;
        margin-top: 0.5rem;
        margin-bottom: -1.5rem;
    }
}
</style>
